<template>
  <div
    class="section section-download"
    id="#download-section"
    data-background-color="black"
    style="border-radius: 20px 20px 0px 0px;margin-top:-25px;"
  >
    <div class="container">
      <div class="row text-center mt-5">
        <div class="col-md-8 ml-auto mr-auto">
          <h2>Want more?</h2>
          <h5 class="description">Keep yourself updated with upcoming offers by following us on social media! Links are below:
          </h5>
        </div>
        <div class="text-center justify-center col-md-12">
          <a
                  style="margin-right:20px;"
                  target="_blank"
                  href="https://www.twitter.com/transpo_india"
                  class="btn btn-neutral btn-icon btn-twitter btn-round btn-lg"
                  rel="tooltip"
                  title="Follow us"
          >
            <i class="fab fa-twitter"></i>
          </a>
          <a
                  style="margin-right:20px;"
                  target="_blank"
                  href="https://www.facebook.com/india.transpo"
                  class="btn btn-neutral btn-icon btn-facebook btn-round btn-lg"
                  rel="tooltip"
                  title="Like us"
          >
            <i class="fab fa-facebook-square"></i>
          </a>
          <a
                  style="margin-right:20px;"
                  target="_blank"
                  href="https://www.linkedin.com/company/transpo"
                  class="btn btn-neutral btn-icon btn-linkedin btn-lg btn-round"
                  rel="tooltip"
                  title="Follow us"
          >
            <i class="fab fa-linkedin"></i>
          </a>
          <a
                  target="_blank"
                  href="https://instagram.com/transpoindia"
                  class="btn btn-neutral btn-icon btn-round btn-lg"
                  rel="tooltip"
                  title="Follow on Instagram"
          >
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
